import { paletteBase } from '@abg/kit-base';

import { DropdownStyleParts } from './types';

export const dropdownBaseStyleParts: DropdownStyleParts = {
  selectMenu: {
    '&.MuiSelect-root': {
      '.MuiSelect-select': {
        height: '24px',
        padding: '16px',
        fontWeight: 400,
      },

      '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px',
          borderColor: paletteBase.black,
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '0',
      },
    },
  },
  selectMenuIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
    cursor: 'pointer',
  },
  selectMenuArrowIcon: {
    fontSize: 16,
    marginRight: '16px',
  },
  selectMenuList: {
    maxHeight: {
      xs: '380px',
      sm: '432px',
    },
  },
  selectMenuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: { sm: '52px' },
    paddingX: '8px',
    marginX: '4px',
    '.MuiSvgIcon-root': {
      visibility: 'hidden',
    },
    '.MuiTypography-root': {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
    },
    '&.Mui-selected': {
      backgroundColor: paletteBase.black + ' !important',
      '.MuiTypography-root': {
        fontWeight: 500,
        color: paletteBase.white100,
      },
      '.MuiSvgIcon-root': {
        visibility: 'visible',
        path: {
          stroke: paletteBase.white100,
        },
      },
    },
  },
  selectMenuItemIcon: {
    marginLeft: '10px',
    width: '8px',
  },
  placeholder: {
    color: paletteBase.neutralGrey400,
  },
};
